import {
  getObject,
  getOptionalObject,
} from "@surya-digital/leo-ts-types";
import { Code, CodeDTO } from "../types/code";
import { GridSingleSelectGraphTypeV1 } from "./gridSingleSelectGraphTypeV1";
import { GridMultiSelectGraphTypeV1 } from "./gridMultiSelectGraphTypeV1";
import { OpenEndedGraphTypeV1 } from "./openEndedGraphTypeV1";


export namespace GridElementGraphTypeV1Enums {
  export namespace ColumnQuestionType {
    export interface SingleSelectDTO {
      case: string;
      singleSelectGraphType: GridSingleSelectGraphTypeV1.GridSingleSelectGraphTypeV1DTO;
    }
    
    export class SingleSelect {
      readonly isColumnQuestionTypeSingleSelect: boolean = true;
    
      readonly singleSelectGraphType: GridSingleSelectGraphTypeV1.GridSingleSelectGraphTypeV1;
    
    
      constructor(
      singleSelectGraphType: GridSingleSelectGraphTypeV1.GridSingleSelectGraphTypeV1
      ) {
        this.singleSelectGraphType = singleSelectGraphType;
      }
    
      static fromDTO(dto: SingleSelectDTO): SingleSelect {
        const singleSelectGraphType = GridSingleSelectGraphTypeV1.fromDTO(getObject(dto, "singleSelectGraphType", InvalidGridElementGraphTypeV1ColumnQuestionTypeSingleSelectSingleSelectGraphTypeError));
        return new SingleSelect(
          singleSelectGraphType
        );
      }
    
      toDTO(): SingleSelectDTO {
        const dto: SingleSelectDTO = {
          case: "SINGLE_SELECT",
            singleSelectGraphType: GridSingleSelectGraphTypeV1.toDTO(this.singleSelectGraphType)
        };
        return dto;
      }
      }
    
    SingleSelect.prototype.toString = function toString(): string {
      return `ColumnQuestionType.SINGLE_SELECT(singleSelectGraphType='${this.singleSelectGraphType}')`;
    };
    
    export interface SingleSelectWithProportionDTO {
      case: string;
      singleSelectWithProportionGraphType: GridSingleSelectGraphTypeV1.GridSingleSelectGraphTypeV1DTO;
    }
    
    export class SingleSelectWithProportion {
      readonly isColumnQuestionTypeSingleSelectWithProportion: boolean = true;
    
      readonly singleSelectWithProportionGraphType: GridSingleSelectGraphTypeV1.GridSingleSelectGraphTypeV1;
    
    
      constructor(
      singleSelectWithProportionGraphType: GridSingleSelectGraphTypeV1.GridSingleSelectGraphTypeV1
      ) {
        this.singleSelectWithProportionGraphType = singleSelectWithProportionGraphType;
      }
    
      static fromDTO(dto: SingleSelectWithProportionDTO): SingleSelectWithProportion {
        const singleSelectWithProportionGraphType = GridSingleSelectGraphTypeV1.fromDTO(getObject(dto, "singleSelectWithProportionGraphType", InvalidGridElementGraphTypeV1ColumnQuestionTypeSingleSelectWithProportionSingleSelectWithProportionGraphTypeError));
        return new SingleSelectWithProportion(
          singleSelectWithProportionGraphType
        );
      }
    
      toDTO(): SingleSelectWithProportionDTO {
        const dto: SingleSelectWithProportionDTO = {
          case: "SINGLE_SELECT_WITH_PROPORTION",
            singleSelectWithProportionGraphType: GridSingleSelectGraphTypeV1.toDTO(this.singleSelectWithProportionGraphType)
        };
        return dto;
      }
      }
    
    SingleSelectWithProportion.prototype.toString = function toString(): string {
      return `ColumnQuestionType.SINGLE_SELECT_WITH_PROPORTION(singleSelectWithProportionGraphType='${this.singleSelectWithProportionGraphType}')`;
    };
    
    export interface MultiSelectDTO {
      case: string;
      multiSelectGraphType: GridMultiSelectGraphTypeV1.GridMultiSelectGraphTypeV1DTO;
    }
    
    export class MultiSelect {
      readonly isColumnQuestionTypeMultiSelect: boolean = true;
    
      readonly multiSelectGraphType: GridMultiSelectGraphTypeV1.GridMultiSelectGraphTypeV1;
    
    
      constructor(
      multiSelectGraphType: GridMultiSelectGraphTypeV1.GridMultiSelectGraphTypeV1
      ) {
        this.multiSelectGraphType = multiSelectGraphType;
      }
    
      static fromDTO(dto: MultiSelectDTO): MultiSelect {
        const multiSelectGraphType = GridMultiSelectGraphTypeV1.fromDTO(getObject(dto, "multiSelectGraphType", InvalidGridElementGraphTypeV1ColumnQuestionTypeMultiSelectMultiSelectGraphTypeError));
        return new MultiSelect(
          multiSelectGraphType
        );
      }
    
      toDTO(): MultiSelectDTO {
        const dto: MultiSelectDTO = {
          case: "MULTI_SELECT",
            multiSelectGraphType: GridMultiSelectGraphTypeV1.toDTO(this.multiSelectGraphType)
        };
        return dto;
      }
      }
    
    MultiSelect.prototype.toString = function toString(): string {
      return `ColumnQuestionType.MULTI_SELECT(multiSelectGraphType='${this.multiSelectGraphType}')`;
    };
    
    export interface OpenEndedDTO {
      case: string;
      openEndedGraphType: OpenEndedGraphTypeV1.OpenEndedGraphTypeV1DTO;
    }
    
    export class OpenEnded {
      readonly isColumnQuestionTypeOpenEnded: boolean = true;
    
      readonly openEndedGraphType: OpenEndedGraphTypeV1.OpenEndedGraphTypeV1;
    
    
      constructor(
      openEndedGraphType: OpenEndedGraphTypeV1.OpenEndedGraphTypeV1
      ) {
        this.openEndedGraphType = openEndedGraphType;
      }
    
      static fromDTO(dto: OpenEndedDTO): OpenEnded {
        const openEndedGraphType = OpenEndedGraphTypeV1.fromDTO(getObject(dto, "openEndedGraphType", InvalidGridElementGraphTypeV1ColumnQuestionTypeOpenEndedOpenEndedGraphTypeError));
        return new OpenEnded(
          openEndedGraphType
        );
      }
    
      toDTO(): OpenEndedDTO {
        const dto: OpenEndedDTO = {
          case: "OPEN_ENDED",
            openEndedGraphType: OpenEndedGraphTypeV1.toDTO(this.openEndedGraphType)
        };
        return dto;
      }
      }
    
    OpenEnded.prototype.toString = function toString(): string {
      return `ColumnQuestionType.OPEN_ENDED(openEndedGraphType='${this.openEndedGraphType}')`;
    };
    
  
    export type ColumnQuestionType = SingleSelect | SingleSelectWithProportion | MultiSelect | OpenEnded;
  
    export type ColumnQuestionTypeDTO = SingleSelectDTO | SingleSelectWithProportionDTO | MultiSelectDTO | OpenEndedDTO;
  
    export const fromDTO = (dto: ColumnQuestionTypeDTO): ColumnQuestionType => {
      switch (dto.case) {
        case "SINGLE_SELECT":
            return SingleSelect.fromDTO(dto as SingleSelectDTO);
        case "SINGLE_SELECT_WITH_PROPORTION":
            return SingleSelectWithProportion.fromDTO(dto as SingleSelectWithProportionDTO);
        case "MULTI_SELECT":
            return MultiSelect.fromDTO(dto as MultiSelectDTO);
        case "OPEN_ENDED":
            return OpenEnded.fromDTO(dto as OpenEndedDTO);
        default:
          throw new InvalidGridElementGraphTypeV1ColumnQuestionTypeError(
              `Case ${dto.case} is not valid case of ColumnQuestionType.`
          );
      }
    };
  }
  
}
export interface GridElementGraphTypeV1DTO {
  rowCode?: CodeDTO | null;
  columnCode: CodeDTO;
  columnQuestionType: GridElementGraphTypeV1Enums.ColumnQuestionType.ColumnQuestionTypeDTO;
}

export class GridElementGraphTypeV1 {
  readonly isGridElementGraphTypeV1GridElementGraphTypeV1: boolean = true;

  readonly rowCode: Code | null;
  readonly columnCode: Code;
  readonly columnQuestionType: GridElementGraphTypeV1Enums.ColumnQuestionType.ColumnQuestionType;


  constructor(
  rowCode: Code | null = null, 
  columnCode: Code, 
  columnQuestionType: GridElementGraphTypeV1Enums.ColumnQuestionType.ColumnQuestionType
  ) {
    this.rowCode = rowCode;
    this.columnCode = columnCode;
    this.columnQuestionType = columnQuestionType;
  }

  static fromDTO(dto: GridElementGraphTypeV1DTO): GridElementGraphTypeV1 {
    let rowCode = getOptionalObject(dto, "rowCode");
    if(rowCode !== undefined && rowCode !== null) {
      rowCode = Code.fromDTO(getObject(dto, "rowCode", InvalidGridElementGraphTypeV1RowCodeError));
    }
    const columnCode = Code.fromDTO(getObject(dto, "columnCode", InvalidGridElementGraphTypeV1ColumnCodeError));
    const columnQuestionType = GridElementGraphTypeV1Enums.ColumnQuestionType.fromDTO(getObject(dto, "columnQuestionType", InvalidGridElementGraphTypeV1ColumnQuestionTypeError));
    return new GridElementGraphTypeV1(
      rowCode,
      columnCode,
      columnQuestionType
    );
  }

  toDTO(): GridElementGraphTypeV1DTO {
    const dto: GridElementGraphTypeV1DTO = {
        columnCode: this.columnCode.toDTO(),
        columnQuestionType: this.columnQuestionType.toDTO()
    };
    if (this.rowCode !== undefined && this.rowCode !== null){
      dto.rowCode = this.rowCode.toDTO();
    }
    return dto;
  }
  }

GridElementGraphTypeV1.prototype.toString = function toString(): string {
  return `GridElementGraphTypeV1(rowCode='${this.rowCode}',columnCode='${this.columnCode}',columnQuestionType='${this.columnQuestionType}')`;
};

export class InvalidGridElementGraphTypeV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridElementGraphTypeV1Error";
  }
}
export class InvalidGridElementGraphTypeV1RowCodeError extends InvalidGridElementGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridElementGraphTypeV1RowCodeError";
  }
}

export class InvalidGridElementGraphTypeV1ColumnCodeError extends InvalidGridElementGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridElementGraphTypeV1ColumnCodeError";
  }
}

export class InvalidGridElementGraphTypeV1ColumnQuestionTypeError extends InvalidGridElementGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridElementGraphTypeV1ColumnQuestionTypeError";
  }
}

export class InvalidGridElementGraphTypeV1ColumnQuestionTypeSingleSelectError extends InvalidGridElementGraphTypeV1ColumnQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridElementGraphTypeV1ColumnQuestionTypeSingleSelectError";
  }
}

export class InvalidGridElementGraphTypeV1ColumnQuestionTypeSingleSelectSingleSelectGraphTypeError extends InvalidGridElementGraphTypeV1ColumnQuestionTypeSingleSelectError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridElementGraphTypeV1ColumnQuestionTypeSingleSelectSingleSelectGraphTypeError";
  }
}

export class InvalidGridElementGraphTypeV1ColumnQuestionTypeSingleSelectWithProportionError extends InvalidGridElementGraphTypeV1ColumnQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridElementGraphTypeV1ColumnQuestionTypeSingleSelectWithProportionError";
  }
}

export class InvalidGridElementGraphTypeV1ColumnQuestionTypeSingleSelectWithProportionSingleSelectWithProportionGraphTypeError extends InvalidGridElementGraphTypeV1ColumnQuestionTypeSingleSelectWithProportionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridElementGraphTypeV1ColumnQuestionTypeSingleSelectWithProportionSingleSelectWithProportionGraphTypeError";
  }
}

export class InvalidGridElementGraphTypeV1ColumnQuestionTypeMultiSelectError extends InvalidGridElementGraphTypeV1ColumnQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridElementGraphTypeV1ColumnQuestionTypeMultiSelectError";
  }
}

export class InvalidGridElementGraphTypeV1ColumnQuestionTypeMultiSelectMultiSelectGraphTypeError extends InvalidGridElementGraphTypeV1ColumnQuestionTypeMultiSelectError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridElementGraphTypeV1ColumnQuestionTypeMultiSelectMultiSelectGraphTypeError";
  }
}

export class InvalidGridElementGraphTypeV1ColumnQuestionTypeOpenEndedError extends InvalidGridElementGraphTypeV1ColumnQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridElementGraphTypeV1ColumnQuestionTypeOpenEndedError";
  }
}

export class InvalidGridElementGraphTypeV1ColumnQuestionTypeOpenEndedOpenEndedGraphTypeError extends InvalidGridElementGraphTypeV1ColumnQuestionTypeOpenEndedError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridElementGraphTypeV1ColumnQuestionTypeOpenEndedOpenEndedGraphTypeError";
  }
}
